import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Collapse from '@kunukn/react-collapse';
import { t } from 'i18next';
import React, { useState } from 'react';

import redChat from '../../assets/imgs/icons/chat-red.svg';
import { Text } from '../common';
import Tooltip from '../common/Tooltip';

import { SETTINGS_TYPES } from './common/settingsComponents';
import { AccordionContentS, AccordionHeaderS } from './CompanySettingsS';

const CompanySettings = ({ isAdmin, isInitialCompany, updateCompany, setActiveSettingType, defaultPlaceholder }) => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (key) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  return Object.keys(SETTINGS_TYPES).map((key) => {
    const isOpen = !!openSections[key];

    return (
      <div key={key}>
        <AccordionHeaderS onClick={() => toggleSection(key)} isOpen={isOpen}>
          <Text>
            {t(SETTINGS_TYPES[key].title)}

            {SETTINGS_TYPES[key].withWarningText && (
              <Tooltip
                label={
                  <Text weight="400" color="red">
                    <img src={redChat} alt="warn-icon" style={{ transform: 'translateY(6px)', marginRight: '4px' }} />
                    {t('companyEdit.rateWarningMsg.title')}
                  </Text>
                }
                tooltipText={t('companyEdit.rateWarningMsg.desc')}
              />
            )}
          </Text>

          <FontAwesomeIcon icon="chevron-left" />
        </AccordionHeaderS>

        <Collapse isOpen={isOpen} transition="height 300ms cubic-bezier(0.4, 0, 0.2, 1)">
          <AccordionContentS isOpen={isOpen}>
            {SETTINGS_TYPES[key].content({
              isAdmin,
              isInitialCompany,
              updateCompany,
              setActiveSettingType,
              defaultPlaceholder,
            })}
          </AccordionContentS>
        </Collapse>
      </div>
    );
  });
};

export default CompanySettings;
